export const theme1 = '#02af90'
export const theme2 = '#fdd400'
export const theme3 = '#FBFBEF'

export const background = '#f2f2f2'
export const heart = '#B43104'
export const gray = 'gray'
